import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const ClientDocumentsWrapper = styled.div`
  margin-top: ${Spacing.S32};
`
export const ClientListWrapper = styled.div`
  margin-top: ${Spacing.S4};
`
